import {useCallback,memo} from 'react'

//styles
import 'devextreme/dist/css/dx.light.css';
import '../../styles/input/custom-textarea.css'

//components
import { TextArea } from 'devextreme-react/text-area';
import {
    Validator,
    RequiredRule
  } from 'devextreme-react/validator';

const CustomTextarea = ({label, value, setValue,requiredValue,labelSize,isDisabled,onClickLabel,isText}) => {
  const onChangeValue = useCallback((data) => {
      // let filteredData = data.replace(/[<>=]/,'')
      setValue(data)
  }, []);
  const onKeyValidation = useCallback(e=>{
    let regex = /[<>]/
    regex.test(e.event.key) && e.event.preventDefault()
  },[])
  return (
    <div className='custom-textarea' style={labelSize ? {gridTemplateColumns: `${labelSize} calc(100% - ${labelSize} - 20px)`} : {}}>
        <div 
          className='custom-textarea__label' 
          style={onClickLabel ? {cursor: 'pointer'} : {}}
          onClick={onClickLabel ? onClickLabel : _=>{}}
        >
          {label}:{requiredValue ? <span>*</span> : ''}
        </div>
        {
          isText ?
          <div>{value}</div>
          :
          <TextArea
            value={value}
            disabled={isDisabled}
            valueChangeEvent="input"
            onValueChange={onChangeValue}
            height={120}
            maxLength={1000}
            onKeyDown={onKeyValidation}
          >
          {requiredValue &&
            <Validator>
              <RequiredRule message={`${label} is required`} />
            </Validator>
          }
          </TextArea>
        }
        
    </div>
  )
}

export default memo(CustomTextarea)